import MetricBase from "models/metrics/MetricBase";
import PerformanceGroup from "models/groups/PerformanceGroup";
import CurrencyUnit from "models/metrics/unit/CurrencyUnit";
import i18n from "i18next";

class MetricGeneratedBing extends MetricBase {
    constructor() {
        super({
            field: "metric_generated",
            defaultVisibility: true,
            unit: new CurrencyUnit(),
            chartName: i18n.t("metrics.bing-hotel-ads.generated.chartName"),
            serieLabel: i18n.t("metrics.bing-hotel-ads.generated.serieLabel"),
            tooltip: i18n.t("metrics.bing-hotel-ads.generated.tooltip"),
            group: new PerformanceGroup(),
        });
    }
}

export default MetricGeneratedBing;
